import { defineComponent } from '@digitalbranch/app'

import template from './about-me.page.html'
import css from './about-me.page.css'

export const aboutMe = defineComponent({
  name: 'about-me-page',
  template,
  css,
  data(): { imageArm32: string } {
    return {
      imageArm32: '/arm32emulator.0e2a0aa7.png'
    }
  },
})
